import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-asphalt-950 text-white border-t border-asphalt-900">
      {/* Upper Footer */}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* Brand Column */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2 group">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=90,format=auto/assets/ca189e60-8ca7-4520-a859-93fb9daa9500/screenshot-2026-06-18-at-08-22-53-removebg-preview.png" 
                alt="JE Entreprenør Logo" 
                className="h-20 sm:h-24 w-auto object-contain transition-transform duration-300 group-hover:scale-102 brightness-110"
              />
            </Link>
            <div className="flex items-center gap-2 text-xs font-semibold text-safety-orange uppercase tracking-wider">
              Vi dækker hele Sydfyn
            </div>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Hurtige Links</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-white">
              <li>
                <Link to="/" className="hover:text-safety-orange transition-colors duration-150">Forside</Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-safety-orange transition-colors duration-150">Om os</Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-safety-orange transition-colors duration-150">Galleri</Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-safety-orange transition-colors duration-150">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info Column */}
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Kontakt Information</h4>
            <ul className="mt-4 space-y-3.5 text-sm text-white">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-safety-orange mt-1"></i>
                <span>
                  Nyborgvej 506A,<br />
                  5881 Skårup Fyn
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-safety-orange"></i>
                <a href="tel:+4551172145" className="hover:text-safety-orange transition-colors duration-150 whitespace-nowrap">
                  51 17 21 45
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-safety-orange"></i>
                <a href="mailto:je.entreprenor@gmail.com" className="hover:text-safety-orange transition-colors duration-150 whitespace-nowrap">
                  je.entreprenor@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-id-card text-safety-orange"></i>
                <span>CVR: 42629421</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="border-t border-asphalt-900 bg-asphalt-950/50 py-6">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-asphalt-500">
          <p>© {currentYear} JE Entreprenør. Alle rettigheder forbeholdes.</p>
          <p>Udviklet med fokus på kvalitet og holdbarhed.</p>
        </div>
      </div>
    </footer>
  );
}
